import { render, staticRenderFns } from "./SwapNotification.vue?vue&type=template&id=299dd161&scoped=true&lang=html&"
import script from "./SwapNotification.vue?vue&type=script&lang=js&"
export * from "./SwapNotification.vue?vue&type=script&lang=js&"
import style0 from "./SwapNotification.vue?vue&type=style&index=0&id=299dd161&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "299dd161",
  null
  
)

export default component.exports